import { StardogSparqlParser } from 'millan';

export const sparqlParser = new StardogSparqlParser();
